import {
  ExpertPageType,
  type GlobalNavigationItem,
  RankingPageType
} from '../../../../../domain/constants/GlobalNavigation';
import { WebCategory } from '../../../../../domain/model/category/WebCategory';

export interface IGlobalNavigationState {
  currentCategory?: WebCategory;
  currentRanking?: RankingPageType;
  currentExpertPage?: ExpertPageType;
  currentTab?: GlobalNavigationItem;
}

const initialState: IGlobalNavigationState = {
  currentCategory: undefined
};

export default (state: IGlobalNavigationState = initialState) => state;
